import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const ActionStyled = styled(Flex)`
  gap: 36px;
  justify-content: flex-end;
  white-space: nowrap;
`

export const ActionTargetStyled = styled.span`
  line-height: 120%;
  box-sizing: border-box;
  border-bottom: 1px dashed transparent;

  &[aria-expanded='true'] {
    border-bottom: 1px dashed var(--color-divider-4);
  }
`

export const OverflowHideStyled = styled(Flex)`
  overflow-y: auto;
  max-height: 50vh;
`
